import { siteConfig, navLinks } from '@/mocks/site-config';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-heading font-bold text-sm">M</span>
              </div>
              <span className="text-background-50 font-heading font-semibold text-lg">
                {siteConfig.name}
              </span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed">
              {siteConfig.tagline} — 为全球企业提供专业高效的数字化解决方案。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">
              资源中心
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/categories" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  文档中心
                </a>
              </li>
              <li>
                <a href="/categories" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  使用教程
                </a>
              </li>
              <li>
                <a href="/categories" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  更新日志
                </a>
              </li>
              <li>
                <a href="/categories" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-mail-line text-sm"></i>
                <span>contact@mrds.io</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-phone-line text-sm"></i>
                <span>400-888-MRDS</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-map-pin-line text-sm"></i>
                <span>北京市朝阳区科技园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer">
              Cookie 政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}